import { render, staticRenderFns } from "./TestItemSingle.vue?vue&type=template&id=c2cdcf26&scoped=true&"
import script from "./TestItemSingle.vue?vue&type=script&lang=js&"
export * from "./TestItemSingle.vue?vue&type=script&lang=js&"
import style0 from "./TestItemSingle.vue?vue&type=style&index=0&id=c2cdcf26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cdcf26",
  null
  
)

export default component.exports